import { useEffect, useState } from 'react';
import { Box, Button, Text } from '@chakra-ui/react';

export const PWAUpdateNotification = () => {
  const [showUpdate, setShowUpdate] = useState(false);

  useEffect(() => {
    // Listen for update messages from service worker
    const handleMessage = (event) => {
      if (event.data && event.data.type === 'SW_UPDATED') {
        setShowUpdate(true);
      }
    };

    navigator.serviceWorker?.addEventListener('message', handleMessage);

    // Check if there's a waiting service worker
    const checkForUpdates = async () => {
      const registration = await navigator.serviceWorker?.getRegistration();
      if (registration?.waiting) {
        setShowUpdate(true);
      }
    };

    checkForUpdates();

    return () => {
      navigator.serviceWorker?.removeEventListener('message', handleMessage);
    };
  }, []);

  const handleUpdate = () => {
    // Force reload to get new version
    window.location.reload();
  };

  if (!showUpdate) return null;

  return (
    <Box
      position="fixed"
      bottom="20px"
      right="20px"
      bg="gray.800"
      border="3px solid"
      borderColor="orange.500"
      color="white"
      p={3}
      borderRadius="md"
      boxShadow="lg"
      zIndex={9999}
      display="flex"
      alignItems="center"
      gap={3}
    >
      <Text fontSize="sm">
        A new version of TimechainStats is available.
      </Text>
      <Button
        size="sm"
        colorScheme="orange"
        onClick={handleUpdate}
        flexShrink={0}
      >
        Refresh Now
      </Button>
    </Box>
  );
};